import type { CSSProperties, ReactElement } from 'react';

import type { PublicTablet } from '@/domain/models/publicTablet';

import styles from './TabletButton.module.css';
import { useLongPress } from './useLongPress';

/**
 * Перенос `_TabletButton` из `base_url_page.dart`.
 */
export interface TabletButtonProps {
  readonly tablet: PublicTablet;

  /**
   * Готовая CSS-длина: `(871.w - 14.w * 2) / 3`. Считается от ширины ряда,
   * а не из `--sw`, — три карточки и два промежутка тогда гарантированно
   * укладываются в 871.w без спора о дробном пикселе.
   */
  readonly width: string;

  readonly isCurrent: boolean;
  readonly currentLabel: string;
  readonly onTap: () => void;

  /** Необязательный вход по паролю планшета — для получения ключей STT. */
  readonly onLongPress: () => void;
}

export function TabletButton({
  tablet,
  width,
  isCurrent,
  currentLabel,
  onTap,
  onLongPress,
}: TabletButtonProps): ReactElement {
  const handlers = useLongPress({ onTap, onLongPress });
  const className = [styles.button, isCurrent ? styles.current : null]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type="button"
      data-testid={`tablet-${tablet.slug}`}
      className={className}
      style={{ '--tablet-width': width } as CSSProperties}
      {...handlers}
    >
      <span className={styles.name}>{tablet.name}</span>
      <span className={styles.slug}>
        {isCurrent ? `${tablet.slug} · ${currentLabel}` : tablet.slug}
      </span>
    </button>
  );
}
